export default __webpack_public_path__ + "static/media/csvIcon.71b54978.svg";